"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = void 0;
var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "Asc";
    SortOrder["Desc"] = "Desc";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
